import React from 'react';

function Comment(props) {
    const [document, setDocument] = React.useState(undefined);
    React.useEffect(() => {
        if (!props.document || document) {
            return;
        }
        setDocument(props.document);
        const element = props.document.getElementById(props.id);
        if (!element) {
            return;
        }
        element.outerHTML = element.innerHTML;
    }, [props.document]);
    return <div id={props.id} dangerouslySetInnerHTML={{ __html: props.value }}></div>
}

export default Comment;